import { render } from "./ModalFichaTecnicaApp.vue?vue&type=template&id=f93770fa"
import script from "./ModalFichaTecnicaApp.vue?vue&type=script&lang=js"
export * from "./ModalFichaTecnicaApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__